import Block from "components/General/Block";
import { Badge } from "flowbite-react";

const ProductTitle = ({ title, categories }) => {
  return (
    <Block className="w-full p-0 bg-transparent md:p-0 lg:px-8 lg:py-8 lg:bg-light_grey">
      {title && <h1 className="mb-3 font-black">{title}</h1>}

      {categories && categories?.length > 0 && (
        <div className="flex items-start gap-2 lg:items-center">
          <span className="text-xs md:text-sm text-dark-text">Tags</span>
          <div className="flex flex-wrap gap-1">
            {categories?.map((category, idx) => {
              const { name, permalink } = category || {};
              if (!name) return null;

              return (
                <a
                  href={permalink}
                  title={name}
                  key={name + idx}
                  className="no-underline"
                >
                  <Badge
                    color="white"
                    size="xspill"
                  >
                    {name}
                  </Badge>
                </a>
              )
            })}
          </div>
        </div>
      )}
    </Block>
  );
}

export default ProductTitle;